<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <div class="flexBox">
      <text-title :mainTitle="mainTitle" :subheading="subheading" />
      <div class="header-btn-box">
        <a @click="toModifyPage">修改</a>
        <a @click="toSiteManagement">返回</a>
      </div>
    </div>
    <form>
      <div class="form-line">
        <div class="line-text">场地名称：</div>
        <div>{{formData.placeName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">场地图片：</div>
        <img :src="formData.placePic" v-if="formData.placePic" style="width: 160px;height: 90px;" alt="">
        <div v-else>无</div>
      </div>
      <div class="form-line">
        <div class="line-text">场地位置：</div>
        <div>{{formData.location || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">场地所在楼层：</div>
        <div>{{formData.floorNameOnPage || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">场地描述：</div>
        <div>{{formData.description || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">场地设施：</div>
        <div v-if="formData.equipments.length === 0">无</div>
        <div style="flex-direction: column" v-else>
          <div v-for="item in formData.equipments" style="width: 100%;text-align: left;">{{item.equipmentName}}{{item.price}}{{item.unit}}</div>
        </div>
      </div>
      <div class="form-line">
        <div class="line-text">关联门禁：</div>
        <div>{{formData.accessNames || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">是否收费：</div>
        <div>{{formData.isFree === 0 ? '否' : '是'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">收费方式：</div>
        <div>{{formData.payMethod === '0' ? '线下' : '线上'}}</div>
      </div>
      <div class="form-line" v-if="formData.isFree === 1">
        <div class="line-text">收费价格：</div>
        <div v-if="formData.priceUnit.length === 0">无</div>
        <div style="flex-direction: column" v-else>
          <div v-for="item in formData.priceUnit" style="width: 100%;text-align: left;">{{item.money}}元/{{item.unit}}小时</div>
        </div>
      </div>
      <div class="form-line">
        <div class="line-text">备注：</div>
        <div>{{formData.memo || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">责任人：</div>
        <div>{{formData.responsiblePersonName || '无'}}</div>
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import {api} from '../../api/SiteReservation'
  import {errorHandler} from '../../../utils/errorHandler'

  export default {
    components: {
      TextTitle,
      Breadcrumb},
    name: 'person-current',
    data () {
      return {
        breadcrumb: [{
          value: '智慧预约',
          name: 'site-management'
        }, {
          value: '场地管理'
        }],
        mainTitle: '查看场地',
        subheading: '',
        formData: {},
        currentCode: ''
      }
    },
    created () {
      this.currentCode = this.$route.params.id
      this.getPlaceByCode()
    },
    methods: {
      toSiteManagement () {
        this.$router.push({
          name: 'site-management'
        })
      },
      toModifyPage () {
        this.$router.push({
          path: `/site_reservation/site_modify/${this.currentCode}`
        })
      },
      getPlaceByCode () {
        this.$axios.get(`${api.getPlaceByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              if (data.payType === '0') {
                data.chargingStandard = '不收费'
              } else if (data.payType === '1') {
                data.chargingStandard = `${data.unitHour}元/时`
              } else if (data.payType === '2') {
                data.chargingStandard = `${data.unitDay}元/天`
              }
              if (data.buildingName && data.floorName) {
                data.floorNameOnPage = `${data.buildingName}/${data.floorName}`
              } else {
                data.floorNameOnPage = ''
              }
              this.formData = data
            }
          })
          .catch(errorHandler('查询场地失败'))
      }
    }
  }
</script>

<style scoped>
  .flexBox {
    display: flex;
    justify-content: space-between;
  }
  .header-btn-box {
    margin: 20px 0 10px 0;
    color: #337ab7;
    font-size: 14px;
  }
  .header-btn-box a{
    margin-right: 40px;
    cursor: pointer;
  }
  .header-btn-box a:hover{
    color: #00a0e6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 120px;
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/view/SiteReservation/SiteManagement/SiteCurrent.vue